import { IndustryDiscount } from "./industry-discount.model";

export class IndustryDiscountPageableResult {
  private start: number;
  private totalPerPages: number;
  private total: number;
  private data: Array<IndustryDiscount>;

  public getStart(): number {
    return this.start;
  }

  public getTotalPerPages(): number {
    return this.totalPerPages;
  }

  public getTotal(): number {
    return this.total;
  }

  public getData(): Array<IndustryDiscount> {
    return this.data;
  }

  public setStart(value: number) {
    this.start = value;
  }

  public setTotalPerPages(value: number) {
    this.totalPerPages = value;
  }

  public setTotal(value: number) {
    this.total = value;
  }

  public setData(value: Array<IndustryDiscount>) {
    this.data = value;
  }
}
